<div
    class="zbd-auswahl-button"
    [attr.id]="buttonId"
    [ngClass]="{ inactive: !canAdd }"
    (click)="handleButtonPress()"
>
    <div class="zbd-auswahl-icon" [ngClass]="section.name.icon"></div>
    <div class="button-label">{{ section.name.displayName }}</div>
</div>

<div class="pop-over-container">
    <!-- regular screen width -->
    <div
        *ngIf="popoverOpen"
        class="zbd-auswahl-pop-over visible-md-block visible-lg-block"
        [attr.id]="popoverId"
    >
        <div
            *ngFor="let product of products; trackBy: trackSection"
            [ngClass]="{ inactive: !product.canAdd }"
            (click)="handleSelect($event, product)"
        >
            {{ product.name.displayName }}
        </div>
    </div>

    <!-- small screen width -->
    <div
        *ngIf="popoverOpen"
        class="zbd-auswahl-pop-over visible-sm-block visible-xs-block"
        [attr.id]="popoverId"
    >
        <div
            *ngFor="let product of products; trackBy: trackSection"
            [ngClass]="{ inactive: !product.canAdd }"
            (click)="handleSelect($event, product)"
        >
            {{ product.name.displayName }}
        </div>
    </div>
</div>
